import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ChannelService } from '@app/integration/Channel.service';
import {
  Channel,
  ChannelMappingData,
  sChannelMappingData,
} from '@product/shared/models/integration';
import { tap } from 'rxjs';

@Component({
  selector: 'app-sync-list',
  templateUrl: './sync-list.component.html',
  styleUrls: ['./sync-list.component.less'],
})
export class SyncListComponent extends BaseComponent implements OnInit {
  @Input() syncData: any[] = [];
  @Input() objectId: number;
  showSyncModal = false;
  setOfSelectedChannels = new Set<Channel>();
  constructor(injector: Injector, private channelService: ChannelService) {
    super(injector);
  }

  ngOnInit() {}

  enableSync(data: sChannelMappingData) {
    data.selected = true;
    this.channelService
      .updateSyncData([data])
      .pipe(
        tap(() => {
          const d = this.syncData.find((x) => x.id === data.id);
          d.selected = true;
        })
      )
      .subscribe();
  }
  disableSync(data: sChannelMappingData) {
    data.selected = false;
    this.channelService
      .updateSyncData([data])
      .pipe(
        tap(() => {
          const d = this.syncData.find((x) => x.id === data.id);
          d.selected = false;
        })
      )
      .subscribe();
  }

  selectedChannelsChanged(channels: Set<Channel>) {
    this.setOfSelectedChannels = channels;
  }
  submitChannels() {
    const data: ChannelMappingData[] = [];
    Array.from(this.setOfSelectedChannels).forEach((channel) => {
      data.push({
        ChannelId: channel.ChannelId,
        IntegrationId: channel.IntegrationId,
        ObjectId: this.objectId,
        ObjectType: 12,
        Processed: false,
        Selected: true,
      });
    });
    this.channelService.syncProducts(data).subscribe((response) => {
      this.showSyncModal = false;
      this.syncData = [...response];
      this.message.success('Products synced successfully.');
    });
  }
  cancelSync() {
    this.setOfSelectedChannels.clear();
    this.showSyncModal = false;
  }
}
